import { render, staticRenderFns } from "./groupTeamCreate.vue?vue&type=template&id=5f1ba520&scoped=true&"
import script from "./groupTeamCreate.vue?vue&type=script&lang=js&"
export * from "./groupTeamCreate.vue?vue&type=script&lang=js&"
import style0 from "./groupTeamCreate.vue?vue&type=style&index=0&id=5f1ba520&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f1ba520",
  null
  
)

export default component.exports